import axios from 'axios';

const MediaUploader = (config) => {

    if (config.formData === undefined || config.formData === null) {
        return;
    }

    if (config.onUploadProgress === undefined) {
        config.onUploadProgress = null;
    }

    if (config.responseCallback === undefined) {
        config.responseCallback = () => {};
    }

    if (config.errorCallback === undefined) {
        config.errorCallback = () => {};
    }

    axios({
        url: '/upload.php',
        method: 'POST',
        data: config.formData,
        headers: { "Content-type": "multipart/form-data" },
        withCredentials: true,
        responseType: 'json',
        onUploadProgress: config.onUploadProgress
    })
    .then((response) => {
        if (config.context) {
            config.responseCallback.call(this, response);
        } else {
            config.responseCallback(response);
        }
    })
    .catch((error) => {
        if (config.context) {
            config.responseCallback.call(this, error);
        } else {
            config.errorCallback(error);
        }

    });

};

export default MediaUploader;
